import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { monedaTypeEnum } from '../../enum';
import { getServiciosProfecionales, IsNotNullOrEmptyOrUndefined } from '../../util';
import RenderResumenDocumento from '../shared/RenderResumenDocumento';
import { setLocalForm } from '../../actions';

const ResumenDocumento = (props) => {

    const { localFormState, actualizarTotales, tipoMedioPago } = props;

    let resumenFacturaTemp = {
        CodigoTipoMoneda: {
            CodigoMoneda: "CRC",
            TipoCambio: 1,
        },
        MedioPago: undefined,
        TotalServGravados: 0.00,
        TotalServExentos: 0.00,
        TotalServExonerado: 0.00,
        TotalMercanciasGravadas: 0.00,
        TotalMercanciasExentas: 0.00,
        TotalMercExonerada: 0.00,
        TotalGravado: 0.00,
        TotalExento: 0.00,
        TotalExonerado: 0.00,
        TotalDescuentos: 0.00,
        TotalImpuesto: 0.00,
        TotalIvaDevuelto: 0.00,
        TotalVenta: 0.00,
        TotalVentaNeta: 0.00,
        TotalOtrosCargos: 0.00,
        TotalComprobante: 0.00,
        TotalExonerado: 0.00,
        TotalExonerado: 0.00,
        TotalServNoSujeto: 0.00,
        TotalMercNoSujeta:0.00,
        TotalNoSujeto: 0.00
    }

    const getTotalServNoSujeto = (impuesto, totalServNoSujeto, baseImponible) => {
        if(impuesto.Codigo === "01" && impuesto.CodigoTarifa === "01"){
          totalServNoSujeto = (parseFloat(totalServNoSujeto) + parseFloat(baseImponible)).toFixed(3);
        }
    
       return totalServNoSujeto ? parseFloat(totalServNoSujeto).toFixed(3) : 0.00;
      }
    
    const getTotalMercNoSujeta = (impuesto, totalMercNoSujeta, baseImponible) => {
        if(impuesto.Codigo === "01" && impuesto.CodigoTarifa === "01"){
            totalMercNoSujeta = (parseFloat(totalMercNoSujeta) + parseFloat(baseImponible)).toFixed(3);
        }

        return totalMercNoSujeta ? parseFloat(totalMercNoSujeta).toFixed(3) : 0.00;
    }

    useEffect(() => {

        if (actualizarTotales && IsNotNullOrEmptyOrUndefined(localFormState?.DetalleServicio) && IsNotNullOrEmptyOrUndefined(localFormState?.ResumenFactura)) {

            props.onTotalesActualizados();

            let lineaDetalle = localFormState?.DetalleServicio?.LineaDetalle;
            let codigoTipoMoneda = localFormState?.ResumenFactura?.CodigoTipoMoneda;
            let montoTotalExonerado = 0;

            if (codigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Colon) {
                resumenFacturaTemp.CodigoTipoMoneda.CodigoMoneda = monedaTypeEnum.Colon;
                resumenFacturaTemp.CodigoTipoMoneda.TipoCambio = 1;
            } else {
                resumenFacturaTemp.CodigoTipoMoneda.CodigoMoneda = codigoTipoMoneda?.CodigoMoneda;
                resumenFacturaTemp.CodigoTipoMoneda.TipoCambio = codigoTipoMoneda?.TipoCambio;
            }

            if (lineaDetalle && lineaDetalle.length > 0) {
                lineaDetalle.forEach((detalle) => {
                    resumenFacturaTemp.TotalDescuentos = parseFloat(resumenFacturaTemp.TotalDescuentos) + parseFloat(getDescuento(detalle.Descuentos));

                    if (getServiciosProfecionales(detalle.UnidadMedida)) {
                        if (!IsNotNullOrEmptyOrUndefined(resumenFacturaTemp.TotalImpuesto)) {
                            resumenFacturaTemp.TotalServExentos = parseFloat(resumenFacturaTemp.TotalServExentos) + parseFloat((parseFloat(detalle.Cantidad) * parseFloat(detalle.PrecioUnitario)) - parseFloat(resumenFacturaTemp.TotalDescuentos));
                        }

                        detalle.Impuestos?.Impuesto?.map((imp) => {
                            if ((getExoneracion(imp.Exoneracion) !== 0)) {
                                montoTotalExonerado = montoTotalExonerado + parseFloat(imp.Exoneracion.MontoExoneracion);
                                let totalExoneLinea = parseFloat((getExoneracion(imp.Exoneracion) / (imp.Tarifa)) * (parseFloat(detalle.Cantidad) * parseFloat(detalle.PrecioUnitario)));
                                resumenFacturaTemp.TotalServExonerado = parseFloat(resumenFacturaTemp.TotalServExonerado) + totalExoneLinea;
                                resumenFacturaTemp.TotalServGravados = parseFloat(resumenFacturaTemp.TotalServGravados) + parseFloat((parseFloat(detalle.Cantidad) * parseFloat(detalle.PrecioUnitario)) - totalExoneLinea);

                                //if (imp.Monto >= imp.Exoneracion.MontoExoneracion) {
                                resumenFacturaTemp.TotalImpuesto = parseFloat(resumenFacturaTemp.TotalImpuesto) + parseFloat(imp.Monto);
                                //}

                            } else {
                                if (IsNotNullOrEmptyOrUndefined(imp) && IsNotNullOrEmptyOrUndefined(imp?.Tarifa)) {
                                    resumenFacturaTemp.TotalServGravados = parseFloat(resumenFacturaTemp.TotalServGravados) + parseFloat(detalle.Cantidad) * parseFloat(detalle.PrecioUnitario);
                                    resumenFacturaTemp.TotalImpuesto = parseFloat(resumenFacturaTemp.TotalImpuesto) + parseFloat(imp.Monto);
                                }
                                else {
                                    resumenFacturaTemp.TotalServExentos = parseFloat(resumenFacturaTemp.TotalServExentos) + parseFloat(detalle.Cantidad * detalle.PrecioUnitario);
                                }
                            }
                            resumenFacturaTemp.TotalServNoSujeto = getTotalServNoSujeto(imp,  resumenFacturaTemp.TotalServNoSujeto, detalle.BaseImponible);

                        });
                    } else {
                        if (!IsNotNullOrEmptyOrUndefined(resumenFacturaTemp.TotalImpuesto)) {
                            resumenFacturaTemp.TotalMercanciasExentas = parseFloat(resumenFacturaTemp.TotalMercanciasExentas) + parseFloat((detalle.Cantidad * detalle.PrecioUnitario) - parseFloat(resumenFacturaTemp.TotalDescuentos));
                        }

                        detalle.Impuestos?.Impuesto?.map((imp) => {
                            if ((getExoneracion(imp.Exoneracion) !== 0)) {
                                montoTotalExonerado = montoTotalExonerado + parseFloat(imp.Exoneracion.MontoExoneracion);
                                let totalExoneLinea = parseFloat((getExoneracion(imp.Exoneracion) / parseFloat(imp.Tarifa)) * (parseFloat(detalle.Cantidad) * parseFloat(detalle.PrecioUnitario)));
                                resumenFacturaTemp.TotalMercExonerada =  parseFloat(resumenFacturaTemp.TotalMercExonerada) + totalExoneLinea;
                                resumenFacturaTemp.TotalMercanciasGravadas = parseFloat(resumenFacturaTemp.TotalMercanciasGravadas) + parseFloat((detalle.Cantidad * detalle.PrecioUnitario) - totalExoneLinea);

                                //if (imp.Monto >= imp.Exoneracion.MontoExoneracion) {
                                resumenFacturaTemp.TotalImpuesto = parseFloat(resumenFacturaTemp.TotalImpuest) + parseFloat(imp.Monto);
                                // }

                            }
                            else {
                                if (IsNotNullOrEmptyOrUndefined(imp) && IsNotNullOrEmptyOrUndefined(imp?.Tarifa)) {
                                    resumenFacturaTemp.TotalMercanciasGravadas = parseFloat(resumenFacturaTemp.TotalMercanciasGravadas) + parseFloat(detalle.Cantidad) * parseFloat(detalle.PrecioUnitario);
                                    resumenFacturaTemp.TotalImpuesto = parseFloat(resumenFacturaTemp.TotalImpuesto) + parseFloat(imp.Monto);
                                }
                                else {
                                    resumenFacturaTemp.TotalMercanciasExentas = parseFloat(resumenFacturaTemp.TotalMercanciasExentas) + parseFloat(detalle.Cantidad) * parseFloat(detalle.PrecioUnitario);
                                }

                            }

                            resumenFacturaTemp.TotalMercNoSujeta = getTotalMercNoSujeta(imp, resumenFacturaTemp.TotalMercNoSujeta, detalle.BaseImponible);
                        });
                    }

                    resumenFacturaTemp.TotalNoSujeto = (parseFloat(resumenFacturaTemp.TotalServNoSujeto) + parseFloat(resumenFacturaTemp.TotalMercNoSujeta)).toFixed(3);
                    resumenFacturaTemp.TotalServGravados = (parseFloat(resumenFacturaTemp.TotalServGravados) - parseFloat(resumenFacturaTemp.TotalServNoSujeto)).toFixed(3);
                    resumenFacturaTemp.TotalMercanciasGravadas = (parseFloat(resumenFacturaTemp.TotalMercanciasGravadas) - parseFloat(resumenFacturaTemp.TotalMercNoSujeta)).toFixed(3);

                    resumenFacturaTemp.TotalImpuesto = parseFloat(resumenFacturaTemp.TotalImpuesto) - parseFloat(montoTotalExonerado);
                    resumenFacturaTemp.TotalGravado = parseFloat(resumenFacturaTemp.TotalServGravados) + parseFloat(resumenFacturaTemp.TotalMercanciasGravadas);
                    resumenFacturaTemp.TotalExento = parseFloat(resumenFacturaTemp.TotalServExentos) + parseFloat(resumenFacturaTemp.TotalMercanciasExentas);
                    resumenFacturaTemp.TotalExonerado = parseFloat(resumenFacturaTemp.TotalServExonerado) + parseFloat(resumenFacturaTemp.TotalMercExonerada);
                    resumenFacturaTemp.TotalVenta = parseFloat(resumenFacturaTemp.TotalExento) + parseFloat(resumenFacturaTemp.TotalGravado) + parseFloat(resumenFacturaTemp.TotalExonerado)  +  parseFloat(resumenFacturaTemp.TotalServNoSujeto) +  parseFloat(resumenFacturaTemp.TotalMercNoSujeta);
                    resumenFacturaTemp.TotalVentaNeta = parseFloat(parseFloat(resumenFacturaTemp.TotalVenta) - parseFloat(resumenFacturaTemp.TotalDescuentos));
                    resumenFacturaTemp.TotalComprobante = parseFloat(resumenFacturaTemp.TotalVentaNeta) + parseFloat(resumenFacturaTemp.TotalImpuesto);

                    resumenFacturaTemp.TotalMercanciasGravadas = resumenFacturaTemp.TotalMercanciasGravadas ? parseFloat(resumenFacturaTemp.TotalMercanciasGravadas).toFixed(3) : 0;
                    resumenFacturaTemp.TotalServGravados = resumenFacturaTemp.TotalServGravados ? parseFloat(resumenFacturaTemp.TotalServGravados).toFixed(3) : 0;
                    resumenFacturaTemp.TotalImpuesto = resumenFacturaTemp.TotalImpuesto.toFixed(3);
                    resumenFacturaTemp.TotalGravado = resumenFacturaTemp.TotalGravado.toFixed(3);
                    resumenFacturaTemp.TotalExento = resumenFacturaTemp.TotalExento.toFixed(3);
                    resumenFacturaTemp.TotalExonerado = resumenFacturaTemp.TotalExonerado.toFixed(3);
                    resumenFacturaTemp.TotalVenta = resumenFacturaTemp.TotalVenta.toFixed(3);
                    resumenFacturaTemp.TotalVentaNeta = resumenFacturaTemp.TotalVentaNeta.toFixed(3);
                    resumenFacturaTemp.TotalComprobante = resumenFacturaTemp.TotalComprobante.toFixed(3);
                    resumenFacturaTemp.MedioPago = [
                            {
                                TipoMedioPago: tipoMedioPago,
                                TotalMedioPago: resumenFacturaTemp.TotalComprobante,
                            }
                    ];
                });

                props.setLocalForm({
                    ...localFormState,
                    ResumenFactura: resumenFacturaTemp
                });

            }
            else {
                props.setLocalForm({
                    ...localFormState,
                    ResumenFactura: resumenFacturaTemp
                });

                return;
            }
        }

    }, [actualizarTotales, localFormState?.DetalleServicio]);

    const getDescuento = (descuentos) => {
        if (IsNotNullOrEmptyOrUndefined(descuentos)) {
            let valorDescuento = 0.00;
            descuentos.Descuento.map(descuentosProducto => {
                valorDescuento += descuentosProducto.MontoDescuento;
            })
            return valorDescuento;
        }
        return parseFloat(0);
    }

    const getExoneracion = (exoneracion) => {
        if (IsNotNullOrEmptyOrUndefined(exoneracion?.MontoExoneracion) && exoneracion.MontoExoneracion > 0) {
            return parseFloat(exoneracion.TarifaExonerada);
        }
        return parseFloat(0);
    }

    return (
        <>
            <RenderResumenDocumento ResumenFactura={localFormState?.ResumenFactura} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        localFormState: state.localFormState,
    };
}

export default connect(mapStateToProps, {
    setLocalForm
})(ResumenDocumento);